import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex w-full items-center justify-center" }
const _hoisted_2 = { class: "card z-30 mt-16 border border-gray-300 bg-white p-8 shadow-xl shadow-gray-500" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "fixed left-0 top-0 z-20 h-full w-full bg-transparent" }, null, -1)

import axios from 'axios';
import {
  GLOBAL_CONSTANTS,
} from 'utilities';
import {
  ref,
} from 'vue';
import {
  useRouter,
} from 'vue-router';
import Bus, {
  NOTIFICATION,
} from '@/bus';
import ConfirmationModal from '@/components/Helper/ConfirmationModal.vue';
import RadioInputHelper from '@/components/Helper/RadioChoiceHelper.vue';
import {
  handleAxiosError,
} from '@/helpers';
import {
  useStore,
} from '@/store';

interface IStockExchange {
  name: string;
  code: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'StockMarketChoice',
  setup(__props) {

const stockExchangeChoices = GLOBAL_CONSTANTS.STOCK_EXCHANGES;
const selectedStockExchange = ref<IStockExchange>();
const router = useRouter();
const showConfirmationModal = ref<boolean>(false);
const isLoading = ref<boolean>(false);

const saveStockExchange = async ():Promise<void> => {
  try {
    isLoading.value = true;
    const response = await axios.put<{message: string}>('/users/stock-exchanges', {
      code: selectedStockExchange.value?.code,
    });
    Bus.emit(NOTIFICATION.SUCCESS, {
      message: response.data.message,
    });

    window.setTimeout(async () => {
      await useStore.auth.refreshUser();
      router.push(useStore.app.homeRoute);
    }, 1 * 1000);
  } catch (e: any) {
    handleAxiosError(e);
  } finally {
    isLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(RadioInputHelper, {
        label: "Please select a Stock Exchange to continue",
        items: _unref(stockExchangeChoices),
        onSelected: _cache[0] || (_cache[0] = ($event: any) => (selectedStockExchange.value = $event))
      }, {
        default: _withCtx((item) => [
          _createTextVNode(_toDisplayString(item.item.name), 1)
        ]),
        _: 1
      }, 8, ["items"]),
      _createElementVNode("button", {
        class: "btn-primary mt-4",
        disabled: !selectedStockExchange.value,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (showConfirmationModal.value = true))
      }, " Save ", 8, _hoisted_3)
    ]),
    _hoisted_4,
    (showConfirmationModal.value)
      ? (_openBlock(), _createBlock(ConfirmationModal, {
          key: 0,
          class: "z-40",
          confirmationText: "Are you sure to save this Stock Exchange ?",
          isLoading: false,
          onCancel: _cache[2] || (_cache[2] = ($event: any) => (showConfirmationModal.value = false)),
          onConfirm: saveStockExchange
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})